import React from 'react';
const FaCheck = require('react-icons/lib/fa/check');
const FaCross = require('react-icons/lib/fa/close');

const ModalContentContentsDifference = React.createClass({
    propTypes: {
        closeFunction: React.PropTypes.func.isRequired,
        setActiveValue: React.PropTypes.func.isRequired
    },
    setCoverLimited() {
        this.props.setActiveValue('property_furnished', 'no');
        this.props.closeFunction();
    },
    setCoverFull() {
        this.props.setActiveValue('property_furnished', 'yes');
        this.props.closeFunction();
    },
    render() {
        return (
            <div>
            <table className="table table-compare mobile-table">
                    <thead>
                    <tr>
                        <th>Cover level</th>
                        <th className="product-name">Limited <br /><span className="small">Fixed at &pound;5,000</span></th>
                        <th className="product-name">Full<br /><span className="small">From &pound;10,000</span></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className="small">
                        <td className="header">
                            Carpets, curtains, sun blinds, light fittings and white goods
                        </td>
                        <td className="product-status" data-label="Limited contents"><FaCheck className="success-colour" /></td>
                        <td className="product-status" data-label="Full contents"><FaCheck className="success-colour" /></td>
                    </tr>
                    <tr className="small">
                        <td className="header">
                            New for old replacement of insured items
                        </td>
                        <td className="product-status" data-label="Limited contents"><FaCheck className="success-colour" /></td>
                        <td className="product-status" data-label="Full contents"><FaCheck className="success-colour" /></td>
                    </tr>
                    <tr className="small">
                        <td className="header">
                            Cover for contents if you temporarily remove them (up to 20% sum insured)
                        </td>
                        <td className="product-status" data-label="Limited contents"><FaCheck className="success-colour" /></td>
                        <td className="product-status" data-label="Full contents"><FaCheck className="success-colour" /></td>
                    </tr>
                    <tr className="small">
                        <td className="header">
                            Loss of rent or re-letting costs you may be faced with after insured damage (up to 30% sum insured)
                        </td>
                        <td className="product-status" data-label="Limited contents"><FaCheck className="success-colour" /></td>
                        <td className="product-status" data-label="Full contents"><FaCheck className="success-colour" /></td>
                    </tr>
                    <tr className="small">
                        <td className="header">
                            Full cover for properties left unoccupied for up to 90 consecutive days
                        </td>
                        <td className="product-status" data-label="Limited contents"><FaCheck className="success-colour" /></td>
                        <td className="product-status" data-label="Full contents"><FaCheck className="success-colour" /></td>
                    </tr>
                    <tr className="small">
                        <td className="header">
                            Legal liability as owner, occupiers legal liability, worldwide personal liability and public liability (up to &pound;5,000,000)
                        </td>
                        <td className="product-status" data-label="Limited contents"><FaCheck className="success-colour" /></td>
                        <td className="product-status" data-label="Full contents"><FaCheck className="success-colour" /></td>
                    </tr>
                    <tr className="small">
                        <td className="header">
                            Employers liability (up to &pound;10,000,000)
                        </td>
                        <td className="product-status" data-label="Limited contents"><FaCheck className="success-colour" /></td>
                        <td className="product-status" data-label="Full contents"><FaCheck className="success-colour" /></td>
                    </tr>
                    <tr className="small">
                        <td className="header">
                            Domestic furniture and furnishings belonging to the landlord
                        </td>
                        <td className="product-status" data-label="Limited contents"><FaCross className="danger-colour" /></td>
                        <td className="product-status" data-label="Full contents"><FaCheck className="success-colour" /></td>
                    </tr>
                    <tr className="small">
                        <td className="header">
                            Emergency Assistance Service included as standard
                        </td>
                        <td className="product-status" data-label="Limited contents"><FaCross className="danger-colour" /></td>
                        <td className="product-status" data-label="Full contents"><FaCheck className="success-colour" /></td>
                    </tr>
                    <tr className="small">
                        <td className="header">
                            Cover for kitchen fixtures and fittings and bathroom sanitaryware (for leasehold properties)
                        </td>
                        <td className="product-status" data-label="Limited contents"><FaCross className="danger-colour" /></td>
                        <td className="product-status" data-label="Full contents"><FaCheck className="success-colour" /></td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td className="hidden-sm-down">&nbsp;</td>
                        <td className="header product-status">
                            <span className="hidden-md-up">Limited contents</span>
                            <div className="clearfix hidden-md-up" />
                            <button onClick={this.setCoverLimited} className="btn btn-confirm">Select</button>
                        </td>
                        <td className="header product-status">
                            <span className="hidden-md-up">Full contents</span>
                            <div className="clearfix hidden-md-up" />
                            <button onClick={this.setCoverFull} className="btn btn-confirm">Select</button>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        );
    }
});

export default ModalContentContentsDifference;


/** WEBPACK FOOTER **
 ** ./src/components/Modals/Content/ModalContentContentsDifference.js
 **/